import classnames from 'classnames'
import { FieldValidator } from 'final-form'
import React, {useCallback, useRef} from 'react'
import { Field } from 'react-final-form'
import { useIntl } from 'react-intl'

import { MultiFileUploader } from './MultiFileUploader'

import styles from './Attachments.module.css'

interface IAttachmentsInput {
  name: string
  onChange: (files: File[], pictures: string[]) => void
  value: HTMLImageElement[]
  supportedExtensions?: string[],
}

const DEFAULT_SUPPORTED_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  //'.zip',
  '.pdf',
]

const AttachmentsInput: React.FC<IAttachmentsInput> = ({
  onChange,
  name,
  value,
  supportedExtensions = DEFAULT_SUPPORTED_EXTENSIONS,
}) => {
  return (
    <MultiFileUploader
      name={name}
      label={`Maksimalno 5mb, jpg|gif|png|pdf`}
      fileTypeError={"Pogrešan tip datoteke"}
      fileSizeError={"Prekoračili ste dopuštenu veličinu"}
      withIcon={true}
      buttonText={'Dodaj priloge'}
      onChange={onChange}
      fileExtensions={supportedExtensions}
      accept={supportedExtensions.join(',')}
      maxFileSize={5602880}
      withPreview
    />
  )
}

interface IAttachmentsProps {
  label?: string
  className?: string
  name: string
  placeholder?: string
  optional?: boolean
  ariaDescription?: string
  disabled?: boolean,
  dependantValue?: any,
  validate?: FieldValidator<HTMLImageElement[]>,
}

export const Attachments: React.FC<IAttachmentsProps> = ({
  name,
  label,
  ariaDescription,
  className = '',
  validate = undefined,
  optional= false,
}) => {
  const requiredValidation = useCallback((value: HTMLImageElement[], _allValues: any) => {
    if (!optional && (value == null || value.length === 0)) {
      return 'Obavezno polje'
    } else {
      return undefined
    }
  }, [optional])

  const validatorRef = useRef<FieldValidator<HTMLImageElement[]>>((value: HTMLImageElement[], allValues: any) => {
    const validations: Array<FieldValidator<HTMLImageElement[]>> = []

    if (!optional) {
      validations.push(requiredValidation)
    }
    if (validate != null) {
      validations.push(validate)
    }

    return validations.reduce((message: string | undefined, fn) => (
        message == null
            ? fn(value, allValues)
            : message
    ), undefined)
  })

  return (
    <Field
      name={name}
      validate={validatorRef.current}
    >
      {({ input, meta }) => (
        <div className={classnames(styles.Attachments, className)}>
          { label && <label htmlFor={name}>{optional ? label : label + " *"}</label> }
          <AttachmentsInput
            name={name}
            onChange={input.onChange}
            value={input.value}
          />
          { meta.touched && meta.error && <div className={classnames('invalid-feedback', styles.ForceVisible)}>{meta.error} 'Prilozi'</div> }
          { ariaDescription && (
            <span
              id={`help-${name}`}
              className={classnames('form-text text-muted', styles.AriaDescription)}
            >
              { ariaDescription }
            </span>
          ) }
        </div>
      )}
    </Field>
  )
}
